module.exports = __webpack_public_path__ + "img/651.15704c84.jpg";